<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- Tree node template for leaf nodes -->
    <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodePadding
        [ngClass]="{ 'active-list-item': node.id === (activeListItem$ | async) }">
        <!-- use a disabled button to provide padding for tree leaf -->
        <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
        <button mat-icon-button disabled type="button"></button>
        <pre
            (click)="navigateToTreeNode(node, $event)"
            tabindex="0"
            role="button"
            (keyup)="navigateToTreeNode(node, $event)"
            >{{ node.name }}</pre
        >
    </mat-tree-node>
    <!-- Tree node template for expandable nodes -->
    <mat-tree-node
        *matTreeNodeDef="let node; when: hasChild"
        matTreeNodePadding
        [class]="{ 'active-list-item': node.id === (activeListItem$ | async) }">
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" type="button">
            <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
        </button>
        <pre
            (click)="navigateToTreeNode(node, $event)"
            tabindex="0"
            role="button"
            (keyup)="navigateToTreeNode(node, $event)"
            >{{ node.name }}</pre
        >
    </mat-tree-node>
</mat-tree>
